import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { range, scaleBand } from 'd3';

@Component({
  selector: 'app-chart-loading-row-basic',
  templateUrl: './chart-loading-row-basic.component.html',
  styleUrls: ['./chart-loading-row-basic.component.scss']
})
export class ChartLoadingRowBasicComponent implements OnChanges {
  @Input() height = 500
  @Input() rows = 12
  gap = 8

  yScale = scaleBand().paddingInner(0.3)

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['height']?.currentValue) {
      this.yScale.range([0, this.height])
    }
    if(changes['rows']?.currentValue) {
      this.yScale.domain(range(0,this.rows).map(d => d.toString()))
    }
  }
}
